import React from 'react';

import { Button, Container } from '@uncinc/uncinc-react-kitchen-sink';
import WysiwygField from '../WysiwygField';

import './style.scss';

interface Props {
  title?: string;
  body?: string;
  children?: JSX.Element;
  link?: string;
  linkTitle?: string;
  linkPosition?: string;
  wide?: boolean;
}

const EntitiesHighlighted = ({
  title, body, children, link, linkTitle, linkPosition = 'center', wide = true,
}: Props) => (
  <div className={`EntitiesHighlighted ${wide && 'wide'}`}>
    <Container small={!wide}>
      <div className="row">
        <div className="col-12">
          {title && (
            <div className="EntitiesHighlighted__title">
              <h2>{title}</h2>
            </div>
          )}
        </div>
        {body && (
          <div className={`col-12 ${wide && 'col-lg-6'}`}>
            <div className="EntitiesHighlighted__body">
              <WysiwygField
                property="schema:text"
                html={body}
              />
            </div>
          </div>
        )}
      </div>
      <div className="EntitiesHighlighted__children">
        {/* Render children */}
        {children}
      </div>

      {(link && linkTitle) && (
        <div className={`EntitiesHighlighted__link ${linkPosition}`}>
          <Button
            href={link}
            className="Button--secondary icon-after icon-arrow-right icon-variant-2"
          >
            {linkTitle}
          </Button>
        </div>
      )}

    </Container>
  </div>
);

export default EntitiesHighlighted;
